import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CREDIT_CARD_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const CreditCardRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CREDIT_CARD_ROUNDED_GLYPH} />;
